import React, { useState, useEffect, useRef } from "react";
import IntlMessages from "@iso/components/utility/intlMessages";
import AssetModalWrapper from "./AssetModal.styles";
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  DatePicker,
  Tabs,
  Card,
  Timeline,
  Popconfirm,
  InputNumber,
  Space,
  Modal,
  Switch,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import modalActions from "@iso/redux/modal/actions";
import Loader from "@iso/components/utility/loader";
import { assetService, activityService, preStartTemplateService } from "@iso/services";
import moment from "moment";
import _ from "lodash";
import styled from "styled-components";
import { dateHelper } from "@iso/lib/helpers/dateHelper";
import L from "leaflet";
import inside from "point-in-polygon";
import { assetCategories } from "@iso/constants/assetCategories";
import { inventoryTypes } from "@iso/constants/inventoryTypes";
import { educationTypes } from "@iso/constants/educationTypes";
import { assetStates } from "@iso/constants/assetStates";
import { waterStorageTypes } from "@iso/constants/waterStorageTypes";
import AddAssetHistoryModal from "./AddAssetHistoryModal";
import ListAcivity from "./ListAcivity";
import AddActivityModal from "./AddActivityModal";
import AssetHistory from "./AssetHistory";
import {
  Map,
  TileLayer,
  FeatureGroup,
  Polygon,
  Tooltip,
  ZoomControl,
  Marker,
  Popup,
} from "react-leaflet";
import { propertyService, healthsafety, attachment, userService } from "@iso/services";
import { levelTypes } from "@iso/constants/levelTypes";
import {
  getHealthSafetyTypeOptionsByCategory,
  normalizeHealthSafetyType,
  requiresCreationDate,
  requiresLastCheckedDate,
  requiresLocation,
  requiresManufactureDate,
  requiresTags,
} from "@iso/constants/healthSafetyTypes";
import { activityPolicy } from "@iso/constants/activityPolicy";
import { shedTypes } from "@iso/constants/shedTypes";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import { waterTypes } from "@iso/constants/waterTypes";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import SensorTab from "./SensorTab";
import { propertyHelper } from "@iso/lib/helpers/propertyHelper";
import FormTab from "./FormTab";
import FileBrowser from "@iso/components/FileBrowser/FileBrowser";
import SelectedFilesDisplay from "@iso/components/FileBrowser/SelectedFilesDisplay";
const { Option, OptGroup } = Select;
const { closeModal } = modalActions;
const { TabPane } = Tabs;

const EditGeneralAssetModal = (props) => {
  const [form] = Form.useForm();
  const [addHistoryForm] = Form.useForm();
  const [fields, setFields] = useState([]);
  const dispatch = useDispatch();
  const modalVisibility = useSelector((state) => state.modal.modalVisibility);
  const modalData = useSelector((state) => state.modal.modalData);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [assetData, setAssetData] = useState({});
  const activePermission = useSelector(
    (state) => state.permission.activePermission
  );
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [visibleActivity, setVisibleActivity] = useState(false);
  const [assetHistory, setAssetHistory] = useState([]);
  const [currentTab, setCurrentTab] = useState("1");
  const [valueLat, setValueLat] = useState();
  const [valueLng, setValueLng] = useState();
  const activePropertyId = useSelector(
    (state) => state.property.activePropertyId
  );
  const dateFormat = "DD/MM/YYYY";
  const [attachmentId, setAttachmentId] = useState([]);
  const [fileBrowserVisible, setFileBrowserVisible] = useState(false);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const [position, setPosition] = useState([null, null]);
  const [corporateGroupId, setCorporateGroupId] = useState(null);
  const [dataActivity, setDataActivity] = useState([]);
  const [tags, setTags] = useState([]);
  const [permitAttachmentLists, setPermitAttachmentLists] = useState({});
  const [users, setUsers] = useState([]);
  const [checklistTemplates, setChecklistTemplates] = useState([]);
  const [primaryTrainerIsExternal, setPrimaryTrainerIsExternal] = useState(false);
  const [secondaryTrainerHasExternal, setSecondaryTrainerHasExternal] = useState(false);
  const activePropertySubscription = useSelector(
    (state) => state.subscription.activePropertySubscription
  );
  const assetType = Form.useWatch(['asset', 'type'], form);
  const assetCategory = Form.useWatch(['asset', 'category'], form);
  const normalizedHealthSafetyType = React.useMemo(
    () => normalizeHealthSafetyType(assetType),
    [assetType]
  );

  useEffect(() => {
    if (assetCategory === 'health_and_safety' && !requiresTags(normalizedHealthSafetyType) && tags.length) {
      setTags([]);
    }
  }, [assetCategory, normalizedHealthSafetyType, tags.length]);

  useEffect(() => {
    if (assetCategory === 'health_and_safety' && !requiresLocation(normalizedHealthSafetyType)) {
      setValueLat(undefined);
      setValueLng(undefined);
      form.setFieldsValue({
        latitude: undefined,
        longitude: undefined,
      });
    }
  }, [assetCategory, normalizedHealthSafetyType, form]);

  // Handle primary_object_id when category changes
  useEffect(() => {
    if (assetCategory === 'education') {
      // Clear primary_object_id for education assets
      form.setFieldsValue({
        asset: {
          ...form.getFieldValue('asset'),
          primary_object_id: undefined,
        }
      });
    } else if (assetCategory && props.primaryObjects && props.primaryObjects.length > 0) {
      // Set default primary_object_id to first item for non-education assets if not already set
      const currentValue = form.getFieldValue(['asset', 'primary_object_id']);
      if (!currentValue) {
        form.setFieldsValue({
          asset: {
            ...form.getFieldValue('asset'),
            primary_object_id: props.primaryObjects[0].id,
          }
        });
      }
    }
  }, [assetCategory, props.primaryObjects, form]);

  const updateDataAssetHistory = React.useCallback(
    (asset_id, modal_type) => {
      activityService.getList(asset_id, modal_type).then((res) => {
        if (res.code === "0000") {
          setAssetHistory(res.activities.reverse());
          //setLoading(false);
        }
      });
    },
    [assetHistory]
  );

  // Derive property data from parent props instead of calling viewProperty API
  useEffect(() => {
    if (props.property) {
      setPosition([props.property.lat, props.property.lng]);
      setCorporateGroupId(props.property.corporate_group_id || null);
    }
  }, [props.property]);

  const getDataActivity = (id) => {
    healthsafety.getDataActivity(id).then((res) => {
      if (res.code === "0000") {
        setDataActivity(res.activity_policy);
      }
    });
  };
  // updatePropertyDetail removed — property data now comes from props

  // Load users for trainer selection — only when modal is visible
  useEffect(() => {
    if (props.visibleAssetOther && activePropertyId) {
      userService.getUserForProperty(activePropertyId).then(res => {
        if (res && res.code === '0000') {
          setUsers(res.users || []);
        }
      }).catch(err => {
        console.error('Error loading users for trainers:', err);
      });
    }
  }, [props.visibleAssetOther, activePropertyId]);

  // Load custom pre-start checklist templates for the property so machinery
  // assets can be assigned one (falls back to the default checklist otherwise).
  useEffect(() => {
    if (props.visibleAssetOther && activePropertyId) {
      preStartTemplateService.getList(activePropertyId).then(res => {
        if (res && res.code === '0000') {
          setChecklistTemplates(res.templates || []);
        }
      }).catch(err => {
        console.error('Error loading checklist templates:', err);
      });
    }
  }, [props.visibleAssetOther, activePropertyId]);

  const mapRef = useRef();
  const handleChangeTag = (input_tags) => {
    setTags(input_tags);
  };
  const buildAttachmentUrl = (attachment) => {
    if (!attachment) return undefined;
    const rawUrl = attachment.full_path || attachment.url;
    if (!rawUrl) return undefined;
    if (/^https?:\/\//i.test(rawUrl)) {
      return rawUrl;
    }
    const base = process.env.REACT_APP_API_BASE_URL || '';
    return `${base}${rawUrl.startsWith('/') ? '' : '/'}${rawUrl}`;
  };

  useEffect(() => {
    setAssetData(props.dataAsset);
    setValueLat(props.dataAsset.lat);
    setValueLng(props.dataAsset.lng);
    getDataActivity(props.dataAsset.id);

    if (props.dataAsset.attachment?.length > 0) {
      const attachments = props.dataAsset.attachment.map(att => ({
        ...att,
        full_path: buildAttachmentUrl(att),
      }));
      setSelectedAttachments(attachments);
      setAttachmentId(attachments.map(a => a.id));
    } else {
      setSelectedAttachments([]);
      setAttachmentId([]);
    }

    form?.setFieldsValue({
      latitude: props.dataAsset.lat,
      longitude: props.dataAsset.lng,
    });
  }, [props.dataAsset]);

  const handleFileBrowserSelect = (files) => {
    setSelectedAttachments(files);
    setAttachmentId(files.map(f => f.id));
    setFileBrowserVisible(false);
  };

  const handleRemoveAttachment = (fileId) => {
    setSelectedAttachments(prev => prev.filter(f => f.id !== fileId));
    setAttachmentId(prev => {
      const ids = Array.isArray(prev) ? prev : [];
      return ids.filter(id => id !== fileId);
    });
  };

  const handleExpiryDateChange = (targetId, newDate) => {
    attachment.updateAttachment(targetId, { expiry_date: newDate ?? '' }).then(res => {
      if (res && res.code === '0000') {
        setSelectedAttachments(prev => prev.map(f => {
          if (f.id === targetId) {
            return { ...f, expiry_date: newDate };
          }
          return f;
        }));
      }
    });
  };

  const handleUserChange = (targetId, userId) => {
    attachment.updateAttachment(targetId, { user_id: userId ?? '' }).then(res => {
      if (res && res.code === '0000') {
        const updatedUser = res.attachment?.user || null;
        setSelectedAttachments(prev => prev.map(f => {
          if (f.id === targetId) {
            return { ...f, user_id: userId, user: updatedUser };
          }
          return f;
        }));
      }
    });
  };

  const onChange = (key) => {
    setCurrentTab(key);
  };
  const handleClickMap = (e) => {
    const { lat, lng } = e.latlng;
    setValueLng(lng);
    setValueLat(lat);
    form?.setFieldsValue({
      latitude: lat,
      longitude: lng,
    });
  };
  const getLatLng = (cLat, cLng) => {
    const lat = cLat;
    const lng = cLng;
    return new L.LatLng(lat, lng);
  };
  const getRandomLatLng = (coordinates) => {
    var polygon = L.polygon([coordinates]);
    var bounds = polygon.getBounds();
    var x_max = bounds.getEast();
    var x_min = bounds.getWest();
    var y_max = bounds.getSouth();
    var y_min = bounds.getNorth();
    var lat = 0,
      lng = 0;
    var count = 0;
    var area = polygon.getLatLngs()[0].map(function (point) {
      return [point.lat, point.lng];
    });

    while (!inside([lat, lng], area)) {
      lat = y_min + Math.random() * (y_max - y_min);
      lng = x_min + Math.random() * (x_max - x_min);
      count += 1;
      if (count == 100) {
        break;
      }
    }

    return new L.LatLng(lat, lng);
  };

  const cancelModal = () => {
    props.cancelEditModal();
    setActiveTab("1");
    setLoading(false);
    setFileBrowserVisible(false);
    setSelectedAttachments([]);
    setAttachmentId([]);
    form.resetFields();
  };

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        onStore(values);
      })
      .catch((info) => {
        console.error("Validate Failed:", info);
        setLoading(false);
      });
  };

  const onStore = (values) => {
    const selectedObject = _.find(props.primaryObjects, (object) => {
      return object.id === values.asset.primary_object_id;
    });
    var point = null;
    var pointComment = null;
    let normalizedHealthTypeValue = values.asset.type;

    if (values.asset.category === "health_and_safety") {
      normalizedHealthTypeValue = normalizeHealthSafetyType(values.asset.type);
      values.asset.type = normalizedHealthTypeValue;
      if (requiresLocation(normalizedHealthTypeValue) && valueLat !== undefined && valueLng !== undefined) {
        point = getLatLng(valueLat, valueLng);
      }
    } else if (values.asset.category === "education") {
      // Education assets don't have location/coordinates
      point = null;
    } else {
      if (currentTab == 1) {
        if (selectedObject && (!assetData.id || assetData.primary_object_id != selectedObject.id)) {
          var point = getRandomLatLng(selectedObject.area);
        }
      } else {
        if (valueLat !== "" && valueLng !== "") {
          point = getLatLng(valueLat, valueLng);
        }
      }
    }

    // Transform external trainer sentinel values before building the payload.
    // Per customer feedback: each external slot (primary, secondary) accepts at
    // most one external entry. The secondary slot's JSON column is therefore a
    // single-element array.
    if (values.asset.category === 'education') {
      const isPrimaryExt = values.asset.primary_trainer_id === 'external';
      const secIds = (values.asset.secondary_trainer_ids || []).filter(id => id !== 'external');
      const hasSecExt = (values.asset.secondary_trainer_ids || []).includes('external');
      values.asset.primary_trainer_id = isPrimaryExt ? null : values.asset.primary_trainer_id;
      values.asset.primary_external_trainer = isPrimaryExt ? {
        name: values.asset.primary_ext_name,
        email: values.asset.primary_ext_email,
        company: values.asset.primary_ext_company || null,
        phone: values.asset.primary_ext_phone,
      } : null;
      values.asset.secondary_trainer_ids = secIds;
      values.asset.secondary_external_trainers = hasSecExt ? [{
        name: values.asset.sec_ext_name,
        email: values.asset.sec_ext_email,
        company: values.asset.sec_ext_company || null,
        phone: values.asset.sec_ext_phone,
      }] : [];
      delete values.asset.primary_ext_name;
      delete values.asset.primary_ext_email;
      delete values.asset.primary_ext_company;
      delete values.asset.primary_ext_phone;
      delete values.asset.sec_ext_name;
      delete values.asset.sec_ext_email;
      delete values.asset.sec_ext_company;
      delete values.asset.sec_ext_phone;
    }

    const data = {
      facility: {
        ...values.asset,
        date_of_purchase: values.asset.date_of_purchase
          ? dateHelper.dateForAPI(values.asset.date_of_purchase)
          : "",
        manufacture_date: values.asset.manufacture_date
          ? dateHelper.dateForAPI(values.asset.manufacture_date)
          : "",
        warranty_expiry: values.asset.warranty_expiry
          ? dateHelper.dateForAPI(values.asset.warranty_expiry)
          : "",
        next_service_due_date: values.asset.next_service_due_date
          ? dateHelper.dateForAPI(values.asset.next_service_due_date)
          : "",
        expiry_date: values.asset.expiry_date
          ? dateHelper.dateForAPI(values.asset.expiry_date)
          : "",
        last_checked_date: values.asset.last_checked_date
          ? dateHelper.dateForAPI(values.asset.last_checked_date)
          : "",
        creation_date: values.asset.creation_date
          ? dateHelper.dateForAPI(values.asset.creation_date)
          : "",
        // Format active_date for education assets
        active_date: values.asset.active_date
          ? dateHelper.dateForAPI(values.asset.active_date)
          : "",
        point,
        tags:
          values.asset.category === "health_and_safety" && requiresTags(normalizedHealthTypeValue)
            ? tags
            : [],
        attachment_id: attachmentId,
        available_to_contractor: values.asset.available_to_contractor ? 1 : 0,
        property_id: props.propertyId,
      },
    };

    assetService.storeOrUpdate(data, assetData.id).then((res) => {
      if (res.code === "0000") {
        props.onSaved(res.facility);
        setLoading(false);
        cancelModal();
        setTags([]);
        form.resetFields();
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (!props.visibleAssetOther || !assetData?.id) return;
    updateDataAssetHistory(assetData.id, "facilities");
    if (assetData.tags) {
      setTags(assetData.tags.split("|"));
    } else {
      setTags([]);
    }

    const baseFields = [
      {
        name: ["asset", "title"],
        value: assetData.title || "",
      },
      {
        name: ["asset", "available_to_contractor"],
        value: !!assetData.available_to_contractor,
      },
      {
        name: ["asset", "category"],
        value: assetData.category,
      },
      {
        name: ["asset", "other_category"],
        value: assetData.other_category,
      },
      {
        name: ["asset", "type"],
        value: normalizeHealthSafetyType(assetData.type),
      },
      {
        name: ["asset", "other_inventory_type"],
        value: assetData.other_inventory_type,
      },
      {
        name: ["asset", "state"],
        value: assetData.state,
      },
      {
        name: ["asset", "other_state"],
        value: assetData.other_state,
      },
      {
        name: ["asset", "date_of_purchase"],
        value: assetData.date_of_purchase
          ? moment(assetData.date_of_purchase)
          : "",
      },
      {
        name: ["asset", "manufacture_date"],
        value: assetData.manufacture_date
          ? moment(assetData.manufacture_date)
          : "",
      },
      // Machinery lifecycle fields (added 2026-06).
      {
        name: ["asset", "manufacturer"],
        value: assetData.manufacturer || "",
      },
      {
        name: ["asset", "make"],
        value: assetData.make || "",
      },
      {
        name: ["asset", "model"],
        value: assetData.model || "",
      },
      {
        name: ["asset", "serial_vin"],
        value: assetData.serial_vin || "",
      },
      {
        name: ["asset", "registration"],
        value: assetData.registration || "",
      },
      {
        name: ["asset", "warranty_expiry"],
        value: assetData.warranty_expiry ? moment(assetData.warranty_expiry) : "",
      },
      {
        name: ["asset", "service_interval"],
        value: assetData.service_interval ?? "",
      },
      {
        name: ["asset", "service_interval_unit"],
        value: assetData.service_interval_unit || undefined,
      },
      {
        name: ["asset", "current_reading"],
        value: assetData.current_reading ?? "",
      },
      {
        name: ["asset", "reading_unit"],
        value: assetData.reading_unit || undefined,
      },
      // Service reminder config (added 2026-06).
      {
        name: ["asset", "service_reminder_enabled"],
        value: !!assetData.service_reminder_enabled,
      },
      {
        name: ["asset", "next_service_due_date"],
        value: assetData.next_service_due_date ? moment(assetData.next_service_due_date) : "",
      },
      {
        name: ["asset", "next_service_due_reading"],
        value: assetData.next_service_due_reading ?? "",
      },
      {
        name: ["asset", "service_notify_prior_days"],
        value: assetData.service_notify_prior_days ?? 7,
      },
      {
        name: ["asset", "inspection_interval_days"],
        value: assetData.inspection_interval_days ?? "",
      },
      {
        name: ["asset", "inspection_template_id"],
        value: assetData.inspection_template_id || undefined,
      },
      {
        name: ["asset", "description"],
        value: assetData.description || "",
      },
      {
        name: ["asset", "expiry_date"],
        value: assetData.expiry_date ? moment(assetData.expiry_date) : "",
      },
      {
        name: ["asset", "last_checked_date"],
        value: assetData.last_checked_date
          ? moment(assetData.last_checked_date)
          : "",
      },
      {
        name: ["asset", "creation_date"],
        value: assetData.creation_date ? moment(assetData.creation_date) : "",
      },
      {
        name: ["asset", "created_by"],
        value: assetData.created_by ? assetData.created_by : "",
      },
      {
        name: ["asset", "tag_number"],
        value: assetData.tag_number ? assetData.tag_number : "",
      },
      {
        name: ["asset", "primary_object_id"],
        value: assetData.primary_object_id
          ? assetData.primary_object_id
          : (assetData.category !== 'education' && props.primaryObjects && props.primaryObjects.length > 0
              ? props.primaryObjects[0].id
              : ""),
      },
      {
        name: ["asset", "permits"],
        value: (assetData.permits || []).map((permit) => ({
          id: permit.id,
          crop_usage: permit.crop_usage,
          rate: permit.rate,
          permit_code: permit.permit_code,
          expiry_date: permit.expiry_date ? moment(permit.expiry_date) : null,
          attachment_id: permit.attachment_id,
        })),
      },
      {
        name: ["asset", "crops"],
        value: (assetData.crops || []).map((crop) => ({
          id: crop.id,
          crop_name: crop.crop_name,
          rate: crop.rate,
          allow_use: crop.allow_use !== undefined ? !!crop.allow_use : true,
        })),
      },
    ];

    // Add education_asset data to fields if category is education
    if (assetData.category === 'education' && assetData.education_asset) {
      const educationAsset = assetData.education_asset;
      const primaryExt = educationAsset.primary_external_trainer || null;
      const secExtList = educationAsset.secondary_external_trainers || [];
      const secExt = secExtList.length > 0 ? secExtList[0] : null;
      setPrimaryTrainerIsExternal(!!primaryExt);
      setSecondaryTrainerHasExternal(!!secExt);
      const secIds = educationAsset.secondary_trainer_ids || [];
      baseFields.push(
        {
          name: ["asset", "type"],
          value: educationAsset.type || "",
        },
        {
          name: ["asset", "primary_trainer_id"],
          value: primaryExt ? 'external' : (educationAsset.primary_trainer_id || null),
        },
        {
          name: ["asset", "primary_ext_name"],
          value: primaryExt ? primaryExt.name : undefined,
        },
        {
          name: ["asset", "primary_ext_email"],
          value: primaryExt ? primaryExt.email : undefined,
        },
        {
          name: ["asset", "primary_ext_company"],
          value: primaryExt ? primaryExt.company : undefined,
        },
        {
          name: ["asset", "primary_ext_phone"],
          value: primaryExt ? primaryExt.phone : undefined,
        },
        {
          name: ["asset", "secondary_trainer_ids"],
          value: secExt ? [...secIds, 'external'] : secIds,
        },
        {
          name: ["asset", "sec_ext_name"],
          value: secExt ? secExt.name : undefined,
        },
        {
          name: ["asset", "sec_ext_email"],
          value: secExt ? secExt.email : undefined,
        },
        {
          name: ["asset", "sec_ext_company"],
          value: secExt ? secExt.company : undefined,
        },
        {
          name: ["asset", "sec_ext_phone"],
          value: secExt ? secExt.phone : undefined,
        },
        {
          name: ["asset", "active_date"],
          value: educationAsset.active_date ? moment(educationAsset.active_date) : null,
        },
        {
          name: ["asset", "validity_months"],
          value: educationAsset.validity_months || 12,
        },
        {
          name: ["asset", "expiry_date"],
          value: educationAsset.expiry_date ? moment(educationAsset.expiry_date) : null,
        }
      );
    } else if (assetData.category !== 'education') {
      setPrimaryTrainerIsExternal(false);
      setSecondaryTrainerHasExternal(false);
    }

    setFields(baseFields);
  }, [props.propertyId, props.visibleAssetOther, assetData]);

  const renderOptionsAssetCategory = () => {
    let options = [];
    _.forEach(assetCategories, (cat, index) => {
      options.push(
        <Option key={index} value={cat.value}>
          <div>{cat.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a category" allowClear size="large" disabled>
        {options}
      </Select>
    );
  };
  const renderOptionsLevelTypes = () => {
    let options = [];
    _.forEach(levelTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a level" allowClear size="large">
        {options}
      </Select>
    );
  };

  const renderOptionsInventoryType = () => {
    let options = [];
    _.forEach(inventoryTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    });
    return (
      <Select
        placeholder="Select a inventory type"
        allowClear
        size="large"
        disabled
      >
        {options}
      </Select>
    );
  };

  const renderOptionsAssetState = () => {
    let options = [];
    _.forEach(assetStates, (state, index) => {
      options.push(
        <Option key={index} value={state.value}>
          <ColorItemRow>
            <ColorItemPreview
              style={{ backgroundColor: state.color }}
            ></ColorItemPreview>
            <div>{state.label}</div>
          </ColorItemRow>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a state" allowClear size="large">
        {options}
      </Select>
    );
  };
  const healthSafetyOptionGroups = React.useMemo(
    () => getHealthSafetyTypeOptionsByCategory(),
    []
  );

  const renderOptionsHealthSafetyTypes = () => (
    <Select
      placeholder="Select a Health Safety Types"
      allowClear
      size="large"
      disabled
      showSearch
      optionFilterProp="label"
    >
      {healthSafetyOptionGroups.map((group) => (
        <OptGroup key={group.value} label={group.label}>
          {group.options.map((option) => (
            <Option key={option.value} value={option.value} label={option.label}>
              <div>{option.label}</div>
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
  const renderActivityPolicy = () => {
    let options = [];
    _.forEach(activityPolicy, (activity, index) => {
      options.push(
        <Option key={index} value={activity.value}>
          <div>{activity.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a activity" allowClear disabled size="large">
        {options}
      </Select>
    );
  };
  const renderOptionsWaterStorageTypes = () => {
    let options = [];
    _.forEach(waterStorageTypes, (water_type, index) => {
      options.push(
        <Option key={index} value={water_type.value}>
          <div>{water_type.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a water storage type" allowClear size="large">
        {options}
      </Select>
    );
  };

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    });
    return (
      <Select placeholder="Select an object" allowClear size="large">
        {options}
      </Select>
    );
  };

  const [activeTab, setActiveTab] = useState("1");
  const onChangeTab = (key) => {
    setActiveTab(key);
  };

  const addHistory = (object, e) => {
    setVisibleHistory(true);
  };
  const addActivy = (object, e) => {
    setVisibleActivity(true);
  };

  const cancelModalHistory = () => {
    addHistoryForm.resetFields();
    setVisibleHistory(false);
    setLoadingHistory(false);
  };
  const cancelModalActivity = () => {
    setVisibleActivity(false);
  };

  const renderOptionsShedTypes = () => {
    let options = [];
    _.forEach(shedTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a type" allowClear size="large">
        {options}
      </Select>
    );
  };

  const renderOptionsWaterTypes = () => {
    let options = [];
    _.forEach(waterTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a type" allowClear size="large">
        {options}
      </Select>
    );
  };

  const renderEducationTypes = () => {
    return (
      <Select placeholder="Select education type" allowClear size="large">
        {educationTypes.map((type, index) => (
          <Option key={index} value={type.value}>
            {type.label}
          </Option>
        ))}
      </Select>
    );
  };

  const confirmDelete = (del_asset) => {
    if (del_asset.id) {
      assetService.destroy(del_asset.id).then((res) => {
        if (res.code === "0000") {
          cancelModal();
          // props.onSaved(del_asset);
          props.updateDataAssets();
        }
      
      });
      
    }
  };
  return (
    <>
      <AssetModalWrapper
        visible={props.visibleAssetOther}
        onCancel={cancelModal}
        maskClosable={true}
        title={(() => {
          if (props.viewHistory === true) {
            return <IntlMessages id="View History" />;
          } else {
            return props.dataAsset.id ? (
              <IntlMessages id="propertyPage.modal.asset.editAsset" />
            ) : (
              <IntlMessages id="propertyPage.modal.asset.addAsset" />
            );
          }
        })()}
        footer={[
        (!props?.viewHistory ?
        <>
       <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>
        {(activePermission == "owner" || activePermission == "admin") &&
        props.dataAsset.title && (
              <Popconfirm
                placement="bottomRight"
                title={`You are about to delete ${props.dataAsset.title} Asset`}
                onConfirm={confirmDelete.bind(this, props.dataAsset)}
                okText="Yes"
                cancelText="No"
                className="delete-button"
              >
                <Button key="delete" type="danger" style={{ height: 'auto'}}>
                  {<IntlMessages id="propertyPage.modal.delete" />}
                </Button>
              </Popconfirm>
            )}
            </>
       :'' )
      ]}
      >
        {modalLoading ? (
          <Loader />
        ) : (
          <Tabs
            defaultActiveKey="1"
            onChange={onChangeTab}
            className="form-body"
            activeKey={(!props.viewHistory) ? activeTab : '3'}
          >
          {!props?.viewHistory ?
          <>
            <TabPane
              tab={<IntlMessages id="propertyPage.mobModal.detailTab" />}
              key="1"
            >
              <Form
                form={form}
                layout="vertical"
                scrollToFirstError
                fields={fields}
                id="#1"
              >
                <div>
                  <Form.Item
                    name={["asset", "available_to_contractor"]}
                    className="isoInputWrapper"
                    label="Available to contractors"
                    valuePropName="checked"
                  >
                    <Switch checkedChildren="Yes" unCheckedChildren="No" />
                  </Form.Item>
                  <Form.Item
                    name={["asset", "title"]}
                    className="isoInputWrapper"
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                        whitespace: true,
                      },
                      {
                        max: 255,
                        message: "Title must be maximum 255 characters.",
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Input asset title" />
                  </Form.Item>
                  <Form.Item
                    name={["asset", "category"]}
                    className="isoInputWrapper"
                    label="Category"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    {renderOptionsAssetCategory()}
                  </Form.Item>
                  {assetData.category === "other" && (
                    <Form.Item
                      name={["asset", "other_category"]}
                      className="isoInputWrapper"
                      label="Other Category"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                          whitespace: true,
                        },
                        {
                          max: 255,
                          message:
                            "Other Category must be maximum 255 characters.",
                        },
                      ]}
                    >
                      <Input size="large" placeholder="Input other category" />
                    </Form.Item>
                  )}
                  {assetData.category === "inventory" && (
                    <Form.Item
                      name={["asset", "type"]}
                      className="isoInputWrapper"
                      label="Inventory Type"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      {renderOptionsInventoryType()}
                    </Form.Item>
                  )}
                  {assetData.category === "inventory" && (
                    <Form.Item
                      name={["asset", "other_inventory_type"]}
                      className="isoInputWrapper"
                      label="Other Inventory Type"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                          whitespace: true,
                        },
                        {
                          max: 255,
                          message:
                            "Other Inventory Type must be maximum 255 characters.",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="Input other inventory type"
                      />
                    </Form.Item>
                  )}
                  <Row>
                    {assetData.category !== "health_and_safety" && (
                      <Col xs={{ span: 24 }} md={{ span: 11 }}>
                        <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, currentValues) => {
                            return prevValues["asset"];
                          }}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <Form.Item
                                name={["asset", "state"]}
                                className="isoInputWrapper"
                                label={
                                  assetData.category === "water"
                                    ? "Level"
                                    : "State"
                                }
                                rules={
                                  getFieldValue("asset")?.type !== "dam"
                                    ? [
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                      ]
                                    : []
                                }
                              >
                                {assetData.category !== "water"
                                  ? renderOptionsAssetState()
                                  : renderOptionsLevelTypes()}
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>
                    )}
                    {props.dataAsset.category !== "health_and_safety" && props.dataAsset.category !== "education" && (
                      <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                        <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, currentValues) => {
                            return prevValues["asset"];
                          }}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <Form.Item
                                name={["asset", "date_of_purchase"]}
                                className="isoInputWrapper"
                                label="Date Of Purchase"
                                rules={
                                  getFieldValue("asset")?.type !== "dam"
                                    ? [
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                      ]
                                    : []
                                }
                              >
                                <DatePicker
                                  size="large"
                                  style={{ width: "100%" }}
                                  format={dateFormat}
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return (
                        prevValues["asset"] &&
                        prevValues["asset"].state !==
                          currentValues["asset"].state
                      );
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("asset")) {
                        if (getFieldValue("asset").state === "other") {
                          return (
                            <Form.Item
                              name={["asset", "other_state"]}
                              className="isoInputWrapper"
                              label="Other State"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                placeholder="Input other state"
                              />
                            </Form.Item>
                          );
                        }
                      } else {
                        if (assetData.state === "other") {
                          return (
                            <Form.Item
                              name={["asset", "other_state"]}
                              className="isoInputWrapper"
                              label="Other State"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                placeholder="Input other state"
                              />
                            </Form.Item>
                          );
                        }
                      }
                    }}
                  </Form.Item>
                  <Row>
                    {props.dataAsset.category !== "health_and_safety" && props.dataAsset.category !== "education" && (
                      <Col xs={{ span: 24 }} md={{ span: 11 }}>
                        <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, currentValues) => {
                            return prevValues["asset"];
                          }}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <Form.Item
                                name={["asset", "manufacture_date"]}
                                className="isoInputWrapper"
                                label="Manufacture Date"
                                rules={
                                  getFieldValue("asset")?.type !== "dam"
                                    ? [
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                      ]
                                    : []
                                }
                              >
                                <DatePicker
                                  size="large"
                                  style={{ width: "100%" }}
                                  format={dateFormat}
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>
                    )}
                    {assetData.category === "water" && (
                      <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                        <Form.Item
                          name={["asset", "type"]}
                          className="isoInputWrapper"
                          label="Type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          {renderOptionsWaterTypes()}
                        </Form.Item>
                      </Col>
                    )}
                    {props.dataAsset.category !== "water" &&
                      props.dataAsset.category !== "shed" &&
                      props.dataAsset.category !== "health_and_safety" &&
                      props.dataAsset.category !== "education" && (
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "primary_object_id"]}
                            className="isoInputWrapper"
                            label="Location"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            {renderOptionObject(props.primaryObjects)}
                          </Form.Item>
                        </Col>
                      )}
                    {props.dataAsset.category === "shed" && (
                      <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                        <Form.Item
                          name={["asset", "type"]}
                          className="isoInputWrapper"
                          label="Shed Type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          {renderOptionsShedTypes()}
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return prevValues["asset"];
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("asset")) {
                        if (getFieldValue("asset").category === "water") {
                          return (
                            <div>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["asset", "creation_date"]}
                                    className="isoInputWrapper"
                                    label="Creation Date"
                                    rules={
                                      getFieldValue("asset")?.type !== "dam"
                                        ? [
                                            {
                                              required: true,
                                              message: "This field is required",
                                            },
                                          ]
                                        : []
                                    }
                                  >
                                    <DatePicker
                                      size="large"
                                      style={{ width: "100%" }}
                                      format={dateFormat}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 11, offset: 2 }}
                                >
                                  <Form.Item
                                    name={["asset", "last_checked_date"]}
                                    className="isoInputWrapper"
                                    label="Last Checked Date"
                                    rules={
                                      getFieldValue("asset")?.type !== "dam"
                                        ? [
                                            {
                                              required: true,
                                              message: "This field is required",
                                            },
                                          ]
                                        : []
                                    }
                                  >
                                    <DatePicker
                                      size="large"
                                      style={{ width: "100%" }}
                                      format={dateFormat}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Area" key="1">
                                  {currentTab == 1 && (
                                    <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                      <Form.Item
                                        name={["asset", "primary_object_id"]}
                                        className="isoInputWrapper"
                                        label="Location"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                        ]}
                                      >
                                        {renderOptionObject(
                                          props.primaryObjects
                                        )}
                                      </Form.Item>
                                    </Col>
                                  )}
                                </TabPane>

                                <TabPane tab="Location" key="2">
                                  <Map
                                    ref={mapRef}
                                    center={
                                      valueLng !== null
                                        ? [valueLat, valueLng]
                                        : position
                                    }
                                    doubleClickZoom={false}
                                    onclick={handleClickMap}
                                    zoom={16}
                                    zoomControl={true}
                                    style={{ width: "100%", height: "300px" }}
                                  >
                                    { propertyHelper.checkIsGoldPackage(activePropertySubscription) ? (
                                      <ReactLeafletGoogleLayer
                                        type={"satellite"}
                                        useGoogMapsLoader={false}
                                      />
                                    ) : (
                                      <TileLayer
                                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                      />
                                    )}
                                    {valueLat && (
                                      <Marker
                                        position={[valueLat, valueLng]}
                                        draggable={true}
                                      >
                                        <Popup
                                          position={[valueLat, valueLng]}
                                        ></Popup>
                                      </Marker>
                                    )}
                                  </Map>
                                  <Row
                                    style={{
                                      marginTop: "10px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                      <Input value={valueLat} />
                                    </Col>
                                    <Col
                                      xs={{ span: 24 }}
                                      md={{ span: 11, offset: 2 }}
                                    >
                                      <Input value={valueLng} />
                                    </Col>
                                  </Row>
                                </TabPane>
                              </Tabs>
                            </div>
                          );
                        }
                      }
                    }}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return (
                        prevValues["asset"] &&
                        prevValues["asset"].state !==
                          currentValues["asset"].state
                      );
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("asset")) {
                        if (getFieldValue("asset").category === "shed") {
                          return (
                            <div>
                              <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Area" key="1">
                                  {currentTab == 1 && (
                                    <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                      <Form.Item
                                        name={["asset", "primary_object_id"]}
                                        className="isoInputWrapper"
                                        label="Location"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                        ]}
                                      >
                                        {renderOptionObject(
                                          props.primaryObjects
                                        )}
                                      </Form.Item>
                                    </Col>
                                  )}
                                </TabPane>

                                <TabPane tab="Location" key="2">
                                  <Map
                                    ref={mapRef}
                                    center={
                                      valueLng !== null
                                        ? [valueLat, valueLng]
                                        : position
                                    }
                                    doubleClickZoom={false}
                                    onclick={handleClickMap}
                                    zoom={16}
                                    zoomControl={true}
                                    style={{ width: "100%", height: "300px" }}
                                  >
                                    {propertyHelper.checkIsGoldPackage(activePropertySubscription) ? (
                                      <ReactLeafletGoogleLayer
                                        type={"satellite"}
                                        useGoogMapsLoader={false}
                                      />
                                    ) : (
                                      <TileLayer
                                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                      />
                                    )}
                                    {valueLat && (
                                      <Marker
                                        position={[valueLat, valueLng]}
                                        draggable={true}
                                      >
                                        <Popup
                                          position={[valueLat, valueLng]}
                                        ></Popup>
                                      </Marker>
                                    )}
                                  </Map>
                                  <Row
                                    style={{
                                      marginTop: "10px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                      <Input value={valueLat} />
                                    </Col>
                                    <Col
                                      xs={{ span: 24 }}
                                      md={{ span: 11, offset: 2 }}
                                    >
                                      <Input value={valueLng} />
                                    </Col>
                                  </Row>
                                </TabPane>
                              </Tabs>
                            </div>
                          );
                        }
                      }
                    }}
                  </Form.Item>
                  {assetData.category === "education" && (
                    <div>
                      <Form.Item
                        name={["asset", "type"]}
                        className="isoInputWrapper"
                        label="Education Type"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                      >
                        {renderEducationTypes()}
                      </Form.Item>

                      <Form.Item
                        name={["asset", "primary_trainer_id"]}
                        label="Primary Trainer"
                        className="isoInputWrapper"
                        rules={[{ required: true, message: "Primary trainer is required" }]}
                      >
                        <Select
                          placeholder="Select primary trainer"
                          showSearch
                          allowClear
                          size="large"
                          filterOption={(input, option) =>
                            String(option.children).toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={(val) => setPrimaryTrainerIsExternal(val === 'external')}
                        >
                          <Option key="external" value="external" style={{ fontStyle: 'italic' }}>External Trainer</Option>
                          {users.map((user) => (
                            <Option key={user.id} value={user.id}>
                              {user.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {primaryTrainerIsExternal && (
                        <div style={{ background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: 4, padding: '12px 16px', marginBottom: 16 }}>
                          <Row gutter={12}>
                            <Col span={12}>
                              <Form.Item name={["asset", "primary_ext_name"]} label="Full Name" rules={[{ required: true, whitespace: true, message: 'Full name is required' }]}>
                                <Input size="large" placeholder="Trainer full name" />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item name={["asset", "primary_ext_email"]} label="Email" rules={[{ required: true, whitespace: true, type: 'email', message: 'Valid email is required' }]}>
                                <Input size="large" placeholder="trainer@example.com" />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={12}>
                            <Col span={12}>
                              <Form.Item name={["asset", "primary_ext_phone"]} label="Phone Number" rules={[{ required: true, whitespace: true, message: 'Phone number is required' }]}>
                                <Input size="large" placeholder="+61 400 000 000" />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item name={["asset", "primary_ext_company"]} label="Company Name">
                                <Input size="large" placeholder="Company (optional)" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      )}

                      <Form.Item
                        name={["asset", "secondary_trainer_ids"]}
                        label="Secondary Trainers"
                        className="isoInputWrapper"
                      >
                        <Select
                          mode="multiple"
                          placeholder="Select secondary trainers"
                          showSearch
                          allowClear
                          size="large"
                          filterOption={(input, option) =>
                            String(option.children).toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={(vals) => setSecondaryTrainerHasExternal(vals.includes('external'))}
                        >
                          <Option key="external" value="external" style={{ fontStyle: 'italic' }}>External Trainer</Option>
                          {users.map((user) => (
                            <Option key={user.id} value={user.id}>
                              {user.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {secondaryTrainerHasExternal && (
                        <div style={{ background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: 4, padding: '12px 16px', marginBottom: 16 }}>
                          <Row gutter={12}>
                            <Col span={12}>
                              <Form.Item name={["asset", "sec_ext_name"]} label="Full Name" rules={[{ required: true, whitespace: true, message: 'Full name is required' }]}>
                                <Input size="large" placeholder="Trainer full name" />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item name={["asset", "sec_ext_email"]} label="Email" rules={[{ required: true, whitespace: true, type: 'email', message: 'Valid email is required' }]}>
                                <Input size="large" placeholder="trainer@example.com" />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={12}>
                            <Col span={12}>
                              <Form.Item name={["asset", "sec_ext_phone"]} label="Phone Number" rules={[{ required: true, whitespace: true, message: 'Phone number is required' }]}>
                                <Input size="large" placeholder="+61 400 000 000" />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item name={["asset", "sec_ext_company"]} label="Company Name">
                                <Input size="large" placeholder="Company (optional)" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      )}

                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            name={["asset", "active_date"]}
                            label="Active Date"
                            className="isoInputWrapper"
                          >
                            <DatePicker
                              format={dateFormat}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={["asset", "validity_months"]}
                            label="Validity (Months)"
                            className="isoInputWrapper"
                            initialValue={12}
                          >
                            <InputNumber min={1} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item
                        name={["asset", "expiry_date"]}
                        label="Expiry Date"
                        className="isoInputWrapper"
                      >
                        <DatePicker
                          format={dateFormat}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>

                    </div>
                  )}
                  {assetData.category === "machinery" && (
                    <div>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "manufacturer"]}
                            className="isoInputWrapper"
                            label="Manufacturer"
                          >
                            <Input size="large" placeholder="e.g. John Deere" />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "make"]}
                            className="isoInputWrapper"
                            label="Make"
                          >
                            <Input size="large" placeholder="Make" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "model"]}
                            className="isoInputWrapper"
                            label="Model"
                          >
                            <Input size="large" placeholder="Model" />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "serial_vin"]}
                            className="isoInputWrapper"
                            label="Serial / VIN"
                          >
                            <Input size="large" placeholder="Serial number or VIN" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "registration"]}
                            className="isoInputWrapper"
                            label="Registration"
                          >
                            <Input size="large" placeholder="Registration" />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "warranty_expiry"]}
                            className="isoInputWrapper"
                            label="Warranty Expiry"
                          >
                            <DatePicker
                              size="large"
                              style={{ width: "100%" }}
                              format={dateFormat}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "service_interval"]}
                            className="isoInputWrapper"
                            label="Service Interval"
                          >
                            <InputNumber
                              min={0}
                              size="large"
                              style={{ width: "100%" }}
                              placeholder="e.g. 250"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "service_interval_unit"]}
                            className="isoInputWrapper"
                            label="Interval Unit"
                          >
                            <Select
                              size="large"
                              allowClear
                              placeholder="Select unit"
                            >
                              <Option value="hours">Hours</Option>
                              <Option value="km">Kilometres</Option>
                              <Option value="miles">Miles</Option>
                              <Option value="days">Days</Option>
                              <Option value="months">Months</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "current_reading"]}
                            className="isoInputWrapper"
                            label="Current Reading"
                            tooltip="Latest hours/odometer reading. Service logs advance this automatically."
                          >
                            <InputNumber
                              min={0}
                              size="large"
                              style={{ width: "100%" }}
                              placeholder="e.g. 1240"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "reading_unit"]}
                            className="isoInputWrapper"
                            label="Reading Unit"
                          >
                            <Select
                              size="large"
                              allowClear
                              placeholder="Select unit"
                            >
                              <Option value="hours">Hours</Option>
                              <Option value="km">Kilometres</Option>
                              <Option value="miles">Miles</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <h4 style={{ marginTop: 8 }}>Service Reminders</h4>
                      <Form.Item
                        name={["asset", "service_reminder_enabled"]}
                        className="isoInputWrapper"
                        label="Enable service reminders"
                        valuePropName="checked"
                        tooltip="Email + in-app alerts to the assigned user for due/overdue services, warranty and inspections."
                      >
                        <Switch checkedChildren="On" unCheckedChildren="Off" />
                      </Form.Item>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "next_service_due_date"]}
                            className="isoInputWrapper"
                            label="Next Service Due (date)"
                          >
                            <DatePicker
                              size="large"
                              style={{ width: "100%" }}
                              format={dateFormat}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "next_service_due_reading"]}
                            className="isoInputWrapper"
                            label="Next Service Due (reading)"
                            tooltip="Alert once the current reading reaches this value."
                          >
                            <InputNumber
                              min={0}
                              size="large"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "service_notify_prior_days"]}
                            className="isoInputWrapper"
                            label="Notify Prior (days)"
                          >
                            <InputNumber
                              min={0}
                              size="large"
                              style={{ width: "100%" }}
                              placeholder="e.g. 7"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={["asset", "inspection_interval_days"]}
                            className="isoInputWrapper"
                            label="Inspection Cadence (days)"
                            tooltip="Alert if no pre-start inspection has been logged within this many days. Leave blank to disable."
                          >
                            <InputNumber
                              min={0}
                              size="large"
                              style={{ width: "100%" }}
                              placeholder="e.g. 30"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={["asset", "inspection_template_id"]}
                            className="isoInputWrapper"
                            label="Pre-start Checklist"
                            tooltip="Which pre-start inspection checklist this machine uses. Leave blank to use the standard default checklist."
                          >
                            <Select
                              size="large"
                              allowClear
                              placeholder="Default checklist"
                            >
                              {checklistTemplates.map((t) => (
                                <Option key={t.id} value={t.id}>
                                  {t.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return (
                        prevValues["asset"] &&
                        prevValues["asset"].state !==
                          currentValues["asset"].state
                      );
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("asset")) {
                        if (
                          getFieldValue("asset").category ===
                          "health_and_safety"
                        ) {
                          return (
                            <div>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Form.Item
                                    name={["asset", "type"]}
                                    className="isoInputWrapper"
                                    label={
                                      <IntlMessages id="propertyPage.modal.asset.healthSafetyTypes" />
                                    }
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                  >
                                    {renderOptionsHealthSafetyTypes()}
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => {
                                  return (
                                    prevValues["asset"] &&
                                    prevValues["asset"].type !==
                                      currentValues["asset"].type
                                  );
                                }}
                              >
                                {({ getFieldValue }) => {
                                  if (
                                    getFieldValue("asset") &&
                                    getFieldValue("asset").type
                                  ) {
                                    const assetHealthType = normalizeHealthSafetyType(getFieldValue("asset").type);
                                    return (
                                      <div>
                                        <Row>
                                          {requiresLastCheckedDate(assetHealthType) && (
                                            <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                              <Form.Item
                                                name={["asset", "last_checked_date"]}
                                                className="isoInputWrapper"
                                                label="Last Checked Date"
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "This field is required",
                                                  },
                                                ]}
                                              >
                                                <DatePicker
                                                  size="large"
                                                  style={{ width: "100%" }}
                                                  format={dateFormat}
                                                />
                                              </Form.Item>
                                            </Col>
                                          )}
                                          {requiresCreationDate(assetHealthType) && (
                                            <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                              <Form.Item
                                                name={["asset", "creation_date"]}
                                                className="isoInputWrapper"
                                                label="Creation Date"
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "This field is required",
                                                  },
                                                ]}
                                              >
                                                <DatePicker
                                                  size="large"
                                                  style={{ width: "100%" }}
                                                  format={dateFormat}
                                                />
                                              </Form.Item>
                                            </Col>
                                          )}
                                        </Row>
                                        <Row>
                                          <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                            <Form.Item
                                              name={["asset", "expiry_date"]}
                                              className="isoInputWrapper"
                                              label="Expiry Date"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "This field is required",
                                                },
                                              ]}
                                            >
                                              <DatePicker
                                                size="large"
                                                style={{ width: "100%" }}
                                                format={dateFormat}
                                              />
                                            </Form.Item>
                                          </Col>
                                          {requiresManufactureDate(assetHealthType) && (
                                            <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                              <Form.Item
                                                name={["asset", "manufacture_date"]}
                                                className="isoInputWrapper"
                                                label="Manufacture Date"
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "This field is required",
                                                  },
                                                ]}
                                              >
                                                <DatePicker
                                                  size="large"
                                                  style={{ width: "100%" }}
                                                  format={dateFormat}
                                                />
                                              </Form.Item>
                                            </Col>
                                          )}
                                          {requiresTags(assetHealthType) && (
                                            <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                              <Form.Item className="isoInputWrapper" label="Tag">
                                                <TagsInput
                                                  name={["asset", "tags"]}
                                                  value={tags}
                                                  onChange={handleChangeTag}
                                                  addOnBlur="true"
                                                />
                                              </Form.Item>
                                            </Col>
                                          )}
                                        </Row>

                                        {requiresLocation(assetHealthType) ? (
                                          <Row
                                            style={{
                                              marginBottom: "10px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            <Col
                                              xs={{ span: 24 }}
                                              md={{ span: 24 }}
                                              style={{ marginBottom: "10px" }}
                                            >
                                              <Map
                                                ref={mapRef}
                                                center={
                                                  valueLat !== undefined && valueLng !== undefined
                                                    ? [valueLat, valueLng]
                                                    : position
                                                }
                                                doubleClickZoom={false}
                                                onclick={handleClickMap}
                                                zoom={16}
                                                zoomControl={true}
                                                style={{
                                                  width: "100%",
                                                  height: "300px",
                                                }}
                                              >
                                                {activePropertySubscription ===
                                                process.env.REACT_APP_STRIPE_PLAN_GOLD ? (
                                                  <ReactLeafletGoogleLayer
                                                    type={"satellite"}
                                                    useGoogMapsLoader={false}
                                                  />
                                                ) : (
                                                  <TileLayer
                                                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                  />
                                                )}
                                                {valueLat !== undefined && valueLng !== undefined && (
                                                  <Marker
                                                    position={[valueLat, valueLng]}
                                                    draggable={true}
                                                  >
                                                    <Popup position={[valueLat, valueLng]}></Popup>
                                                  </Marker>
                                                )}
                                              </Map>
                                            </Col>

                                            <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                              <Form.Item
                                                className="isoInputWrapper"
                                                name="latitude"
                                                label="Latitude"
                                                value={valueLat}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "This field is required",
                                                  },
                                                ]}
                                              >
                                                <Input value={valueLat} />
                                              </Form.Item>
                                            </Col>
                                            <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                              <Form.Item
                                                className="isoInputWrapper"
                                                name="longitude"
                                                label="Longitude"
                                                value={valueLng}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "This field is required",
                                                  },
                                                ]}
                                              >
                                                <Input value={valueLng} />
                                              </Form.Item>
                                            </Col>
                                          </Row>
                                        ) : (
                                          <Row>
                                            {getFieldValue("asset").category !==
                                              "health_and_safety" && (
                                              <Col
                                                xs={{ span: 24 }}
                                                md={{ span: 11 }}
                                              >
                                                <Form.Item
                                                  shouldUpdate={(
                                                    prevValues,
                                                    currentValues
                                                  ) => {
                                                    return (
                                                      prevValues["asset"] &&
                                                      prevValues["asset"]
                                                        .state !==
                                                        currentValues["asset"]
                                                          .state
                                                    );
                                                  }}
                                                  name={[
                                                    "asset",
                                                    "primary_object_id",
                                                  ]}
                                                  className="isoInputWrapper"
                                                  label="Location"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This field is required",
                                                    },
                                                  ]}
                                                >
                                                  {renderOptionObject(
                                                    props.primaryObjects
                                                  )}
                                                </Form.Item>
                                              </Col>
                                            )}
                                            <Col
                                              xs={{ span: 24 }}
                                              md={{ span: 11 }}
                                            >
                                              <Form.Item
                                                name={["asset", "created_by"]}
                                                className="isoInputWrapper"
                                                label="Created By"
                                                rules={[
                                                  {
                                                    required: true,
                                                    message:
                                                      "This field is required",
                                                  },
                                                ]}
                                              >
                                                <Input
                                                  size="large"
                                                  placeholder="Created By"
                                                />
                                              </Form.Item>
                                            </Col>
                                          </Row>
                                        )}
                                      </div>
                                    );
                                  }
                                }}
                              </Form.Item>

                            </div>
                          );
                        }
                      }
                    }}
                  </Form.Item>
                  <Form.Item
                    name={["asset", "attachment"]}
                    label="Attachments"
                    className="isoInputWrapper"
                  >
                    <Button
                      icon={<UploadOutlined />}
                      onClick={() => setFileBrowserVisible(true)}
                    >
                      <span style={{ marginLeft: 8 }}><IntlMessages id="fileBrowser.selectFiles" /></span>
                    </Button>
                    <SelectedFilesDisplay
                      files={selectedAttachments}
                      onRemove={handleRemoveAttachment}
                      onExpiryDateChange={(id, date) => handleExpiryDateChange(id, date ? dateHelper.dateForAPI(date) : null)}
                      onUserChange={handleUserChange}
                      users={users}
                      dateFormat={dateFormat}
                    />
                  </Form.Item>
                  <Form.Item
                    name={["asset", "description"]}
                    className="isoInputWrapper"
                    label="Description"
                  >
                    <Input.TextArea />
                  </Form.Item>
                  {assetData.category === "education" && assetData.created_by && (
                    <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                      <strong>Created By:</strong> {assetData.created_by}
                    </div>
                  )}
                </div>
              </Form>
            </TabPane>
            {(assetData.category === "health_and_safety" || assetData.category === "education") && (
              <TabPane tab="Activity" key="2">
                <Row>
                  <Col xs={{ span: 7 }} md={{ span: 7 }}>
                    <Button
                      key="submit"
                      className="btn-create-breed"
                      type="primary"
                      onClick={addActivy}
                    >
                      Add Activity
                    </Button>
                  </Col>
                  <Col xs={{ span: 15 }} md={{ span: 17 }}></Col>
                </Row>
                <br />
                <ListAcivity
                  dataId={assetData.id}
                  propertyId={props.propertyId}
                  dataActivity={dataActivity}
                  getDataActivity={getDataActivity}
                />
                <AddActivityModal
                  visibleActivity={visibleActivity}
                  dataId={assetData.id}
                  propertyId={props.propertyId}
                  cancelModalActivity={cancelModalActivity}
                  position={position}
                  getDataActivity={getDataActivity}
                  onSaved={props.onSaved}
                  educationAsset={assetData.education_asset || null}
                />
              </TabPane>
            )}
            </>:''}
            <TabPane
              tab={<IntlMessages id="propertyPage.mobModal.historyTab" />}
              key="3"
            >{!props?.viewHistory ?
              <Row>
                <Col xs={{ span: 7 }} md={{ span: 7 }}>
                  {(activePermission == "owner" ||
                    activePermission == "admin" ||
                    activePermission == "modify") && (
                    <Button
                      key="submit"
                      className="btn-create-breed"
                      type="primary"
                      onClick={addHistory}
                    >
                      {
                        <IntlMessages id="propertyPage.mobModal.historyTab.addHistory" />
                      }
                    </Button>
                  )}
                </Col>
                <Col xs={{ span: 15 }} md={{ span: 17 }}></Col>
              </Row>:''}
              <br />
              <AssetHistory
                assetHistory={assetHistory}
                updateDataAssetHistory={updateDataAssetHistory}
                dataId={assetData.id}
                onAssetUpdated={props.updateDataAssets}
                updatePropertyDetail={props.onSaved}
              />
              <AddAssetHistoryModal
                getDataActivity={getDataActivity}
                visibleHistory={visibleHistory}
                cancelModal={cancelModalHistory}
                primaryObjects={props.primaryObjects}
                model="facilities"
                dataId={assetData.id}
                assetName={assetData.title}
                propertyId={props.propertyId}
                updateDataAssetHistory={updateDataAssetHistory}
                onAssetUpdated={props.updateDataAssets}
                updatePropertyDetail={props.onSaved}
              />
            </TabPane>

            {/* Sensor Tab */}
            <TabPane
              tab={<IntlMessages id="propertyPage.mobModal.sensorTab" />}
              key="4"
            >
              <SensorTab assetId={assetData.id} propertyId={props.propertyId} />
            </TabPane>
            <TabPane
              tab={<IntlMessages id="propertyPage.mobModal.formTab" />}
              key="5"
            >
              <FormTab assetId={assetData.id} propertyId={props.propertyId} />
            </TabPane>
          </Tabs>
        )}
      <FileBrowser
        visible={fileBrowserVisible}
        onCancel={() => setFileBrowserVisible(false)}
        onSelect={handleFileBrowserSelect}
        multiple={true}
        initialSelection={selectedAttachments}
        corporateGroupId={corporateGroupId}
        propertyId={activePropertyId}
      />
      </AssetModalWrapper>
    </>
  );
};

export default EditGeneralAssetModal;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div {
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;
